import type { OwnProps } from './DocumentPreviewModal';

import { Bundles } from '../../../util/moduleLoader';

import useModuleLoader from '../../../hooks/useModuleLoader';

const DocumentPreviewModalAsync = (props: OwnProps) => {
  const { modal } = props;
  const DocumentPreviewModal = useModuleLoader(Bundles.Extra, 'DocumentPreviewModal', !modal);

  return DocumentPreviewModal ? <DocumentPreviewModal {...props} /> : undefined;
};

export default DocumentPreviewModalAsync;
